module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_aurora-eed8481ac0788e3f7a68f2fb54a2ff33.svg";